export default __webpack_public_path__ + "static/media/1276.605140ff.png";